// Module
var code = "<md-dialog class=\"saved-changes-dialog\" layout-padding=\"\"> <div class=\"close_icon\" ng-click=\"close()\"></div> <p class=\"popup-title\">{{title}}</p> </md-dialog> ";
// Exports
var _module_exports = code;;
var path = 'app/modals/saved-changes.modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;